module.exports = __webpack_public_path__ + "img/KSC08689.138439a6.jpg";